import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export type PushPermissionStatus = 'unknown' | 'needed' | 'granted';

export const PUSH_PERMISSION_PROMPT_DISMISSED_KEY =
  'pique-push-permission-prompt-dismissed';

export const pushPermissionStatusAtom = atom<PushPermissionStatus>('unknown');

export const pushPermissionRetryAtom = atom(0);

export const pushPermissionPromptDismissedAtAtom = atomWithStorage<
  number | null
>(PUSH_PERMISSION_PROMPT_DISMISSED_KEY, null, undefined, { getOnInit: true });

export function shouldShowPushPermissionPrompt(
  status: PushPermissionStatus,
  dismissedAt: number | null
): boolean {
  return status === 'needed' && dismissedAt === null;
}

export function isPushPermissionDeniedError(error: unknown): boolean {
  return /\bnot allowed\b/i.test(String(error));
}
